import { ListCollectionDetail } from "@corpuscomplete/core-ui/common/list-collection/detail";
import { ListCollectionDetailPage } from "@corpuscomplete/web/modules/common/list-collection/pages/list-collection-detail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/collections/list/$id")({
  component: () => {
    const { id } = Route.useParams();
    return <ListCollectionDetailPage id={id} />;
  },
  loader: async ({ context: { zero }, params: { id } }) => {
    if (zero) {
      ListCollectionDetail.preload(zero, id);
    }
  },
});
